import { createRestSlice } from "./restSlice";

export type Agent = {
  id: string;
  // Creator attribution: userId for user-created agents, serviceAccountId for
  // agents created by an organization service account (e.g. CI via the CLI).
  userId: string | null;
  serviceAccountId: string | null;
  organizationId: string;
  name: string;
  description: string;
  telephonyId: string | null;
  imageUrl: string | null;
  defaultVoiceId: string;
  strategy: string;
  createdAt: string;
  updatedAt: string;
  lastActivityAt: string | null;
  deletedAt: string | null;
};

const agentSlice = createRestSlice<Agent>("agent", "/v1/agents");

export const agentActions = agentSlice.actions;
export const agentReducer = agentSlice.reducer;
